/* eslint-disable */
import { GET_VISIT_OBJECT_SELECT_TYPES } from "~services/constant/visit";
import HelperOptions from "~component/helper/helper-options";

// 搜索拜访对象的下拉框，对应的字段类型

export default {
  functional: true,
  props: {
    medicalType: {
      type: Number,
      required: false
    }
  },
  render(createElement, context) {
    const { data, props } = context;
    const arr = GET_VISIT_OBJECT_SELECT_TYPES;
    if (props.medicalType && arr.length < 4) {
      arr.push({
        label: "医生",
        value: 4
      });
    }
    return <HelperOptions {...data} options={arr} />;
  }
};
